import React, { useCallback, useEffect, useRef, useState } from "react";
import { ObjectContext, OCVSaveAsPDFProps, Tablewidthandloading } from "./OCVTypes";
import OCVDialog from "./OCVDialog";
import { useTitleContext } from "../../Hooks/useTitleContext";


export const OCVSaveAsPDF: React.FC<OCVSaveAsPDFProps> = (props) => {

  const { setTitle } = useTitleContext();
  setTitle("OCVSaveAsPdf");

  const hash = props[0];
  const Id = props[1];
  const key = props[2];
  
  const [tableState, setTableState] = useState<Tablewidthandloading>({
    maxWidth: 1300,
    isLoading: true,
    pdfWidth: "1300px"
  });

  const getObjectContext = useCallback((): ObjectContext | null => {
    if (!Id || !key) return null;
    
    const isGenericView = hash.includes("GenericView");
    return {
      key: key,
      mdsColumnID: isGenericView ? -1 : parseInt(Id),
      Id: isGenericView ? Id : undefined,
      LauncherMode: isGenericView ? "GenericFlat" : "flat",
      title: "Object Viewer"
    };
  }, [Id, key, hash]);

  const handleWidthChange = useCallback((width: number) => {
    setTableState(prev => {
      const newWidth = Math.max(prev.maxWidth, width);
      return {
        ...prev,
        maxWidth: newWidth,
        pdfWidth: `${newWidth}px`
      };
    });
  }, []);

  const handleLoadingChange = useCallback((isLoading: boolean) => {
    setTableState(prev => ({
      ...prev,
      isLoading
    }));
  }, []);

  const objectContext = getObjectContext();
  const LauncherMode = objectContext?.LauncherMode || "flat";
  if (!objectContext) {
    return <div>Invalid parameters</div>;
  }

  return (
    <div className="row mx-auto mt-4" id="main_section" style={{ padding: '15px 0px' }}>
      <div className="row mx-auto ajax-page-error hide" id="userAlert" />
      
      <div className="col-12 col-xl-12 col-lg-12 m-auto">
        <div id="content">
          <div 
            id="generic_object_viewer_dialog_wrapper" 
            className="hr_comment_dialog_wrapper_flat"
            style={{ 
              display: 'block',
              width: '100%',
              marginLeft: '1%',
              marginRight: '1%'
            }}
          >
            {/* Loading indicator */}
            <div 
              id="generic_object_viewer_loading" 
              className={`ajax-loading-box popup-loading ${!tableState.isLoading ? 'hide' : ''}`}
              style={{ display: tableState.isLoading ? 'flex' : 'none' }}
            >
              <span className="ajax-loading-image" />
              Loading...
            </div>

            {/* Header section */}
            <div id="generic_object_viewer_header" className="generic_object_viewer_header" />
            <div id="generic_object_viewer_message" />

            {/* Content section */}
            <div 
              id="generic_object_viewer_content" 
              style={{ 
                width: `${tableState.maxWidth}px`,
                margin: '0 auto',
                height: 'auto'
              }}
            >
              <input 
                type="hidden" 
                id="hidden_pdf_width" 
                value={tableState.pdfWidth}
              />
              
              <OCVDialog
                key={`${Id}-${key}`}
                clickThruElement={null}
                objectContext={objectContext}
                launcherMode={LauncherMode}
                ocvType=""
                onClose={() => {/* Handle close */}}
                onWidthChange={handleWidthChange}
                onLoadingChange={handleLoadingChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};